import React from "react";
import AllSamplesTable from "../../components/Sample/AllSamplesTable";
import { Box, Typography } from "@mui/material";

const SamplesPage: React.FC = () => {
  document.title = "Samples";

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Samples
      </Typography>
      <AllSamplesTable />
    </Box>
  );
};

export default SamplesPage;
